export default __webpack_public_path__ + "static/media/plus_sign.f51abc81.png";